<!-- @format -->
<template>
  <BaseScrollActive class="base-navigation" :offset="60">
    <template v-for="(value, key) in this.$config.navigation">
      <!-- eslint-disable-next-line -->
      <a
        :href="'#' + value.sitename"
        v-if="key !== 'Trailer'"
        class="nav-item scrollactive-item"
        :class="value.sitename === 'index' ? 'is-active ' : ''"
      >
        {{ key }}
      </a>
      <!-- eslint-disable-next-line -->
      <div
        v-if="key === 'Trailer'"
        @click="yt_video"
        class="nav-item open-trailer"
      >
        Trailer
      </div>
    </template>
  </BaseScrollActive>
</template>

<script>
import { EventBus } from '@/plugins/event-bus.js'

export default {
  methods: {
    yt_video() {
      EventBus.$emit('open-yt-1')
    },
  },
}
</script>

<style lang="scss" scoped>
.base-navigation {
  display: flex;
  flex-direction: row;
  .nav-item {
    position: relative;
    text-decoration: none;
    text-transform: uppercase;
    height: var(--height-header);
    line-height: var(--height-header);
    padding-right: var(--p-link-header);
    color: var(--clr-link-header);
    cursor: pointer;
    font-weight: var(--fw-header);
    /* $min_width: 1024px;
      $max_width: 2560px;
      $min_font: 16px;
      $max_font: $header-fontsize;
      @include fluid-type($min_width, $max_width, $min_font, $max_font); */
    &:hover {
      color: var(--clr-link-hover-header);
    }
  }
}
.is-active {
  color: var(--clr-link-hover-header) !important;
  font-weight: 900 !important;
}
</style>
